export default __webpack_public_path__ + "static/media/hero.52d0fd26.svg";